import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_slot-consulta/artifacts/2ixowcww_logo_600c2634-50e9-4fad-ac45-cb0f2d0622ea.png";

export default function Layout({ children, showFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="app-layout">
      <header className="sticky top-0 z-30 backdrop-blur bg-white/90 border-b border-slate-200">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/" className="flex items-center" data-testid="app-logo-link">
            <img
              src={LOGO_URL}
              alt="Instituto Respirar"
              className="h-9 sm:h-10 w-auto object-contain"
            />
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-2xl mx-auto px-4 py-6 md:py-10">{children}</div>
      </main>

      {showFooter && (
        <footer className="border-t border-slate-200 bg-white/60">
          <div className="max-w-2xl mx-auto px-4 py-5 text-center text-xs text-slate-500">
            Em caso de dúvidas, entre em contato pelo WhatsApp da clínica.
          </div>
        </footer>
      )}
    </div>
  );
}
